import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    const style = {
      position: 'absolute',
      textAlign: 'center',
      top: '50vh',
      width: '100vw',
    };
    return (
      <div style={style}>
        <h1>404 page not found ¯\_(ツ)_/¯</h1>
      </div>
    );
  }
}

export default NotFound;
